module.exports = {"340402001":"大通街道","340402100":"上窑镇","340402101":"洛河镇","340402102":"九龙岗镇","340402200":"孔店乡","340402400":"淮南经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340402.json
// module id = 1173
// module chunks = 0